<div id="clave-web-pyme-content" class="main-container" #mainContainer>
  <router-outlet></router-outlet>
</div>
